module.exports = __webpack_public_path__ + "img/img01.b2493f39.jpg";